import { render, staticRenderFns } from "./InvestmentAccountPage.vue?vue&type=template&id=0b5d949e"
import script from "./InvestmentAccountPage.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports